var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 4.38343V15.6166C4.16675 15.991 4.41636 16.3194 4.77705 16.4196L10.6104 18.0399C11.1414 18.1874 11.6667 17.7881 11.6667 17.237V2.76302C11.6667 2.21192 11.1413 1.81259 10.6103 1.96009L4.77704 3.5805C4.41636 3.68069 4.16675 4.00909 4.16675 4.38343Z",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.3335V16.6668H15.8334V4.16683C15.8334 3.7066 15.4603 3.3335 15.0001 3.3335H11.6667Z",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 10.8332V9.1665",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 16.6665H18.3333",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 16.6665H5.41675",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateDetails);
export default __webpack_public_path__ + "static/media/gate-details.911d2da3f671a46c1940628c0692cdfb.svg";
export { ForwardRef as ReactComponent };